import React from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Link } from '~/eds/src/components/Link/Link';
import { StatusText } from '~/eds/src/components/StatusText/StatusText';
import { TruncateText } from '~/eds/src/components/Text/subcomponents/TruncateText';
import { EntityType } from '~/enums/EntityType';
import { RoutePathType } from '~/routing/enums';

import { useResolveTargetEntityDetails } from '../hooks/useResolveTargetEntityDetails';
import { ModelResult } from '../types/model';

interface Props {
  modelResult: ModelResult;
  readOnly?: boolean;
}

export const ModelResultTargetEntity = ({ modelResult, readOnly }: Props) => {
  const intl = useIntl();
  const { targetEntity, targetEntityDetails, versions, id } = modelResult;

  const [resolvedTargetEntityDetails, isResolvingTargetEntity] =
    useResolveTargetEntityDetails(targetEntity);

  const label =
    targetEntityDetails?.label ?? resolvedTargetEntityDetails?.label ?? '–';
  const hasNoVersions = versions.length === 0;

  return (
    <ContentContainer
      loadingContent={{
        isLoading: isResolvingTargetEntity,
        shimmer: {
          height: '100%',
        },
      }}
    >
      {hasNoVersions ? (
        <StatusText
          icon="status-danger"
          iconTooltip={intl.formatMessage({
            id: 'ModelResultTargetEntity.noVersionsTooltip',
            defaultMessage: 'This model has no versions, please delete it.',
            description: 'Tooltip shown when a model has no versions',
          })}
          text={label}
        />
      ) : readOnly ? (
        <TruncateText>{label}</TruncateText>
      ) : (
        <Link
          shouldTruncate
          pathname={`${RoutePathType.AutomationHubFields}/${id}`}
          search={
            targetEntityDetails?.type === EntityType.DocumentAttachedData
              ? '?type=table'
              : undefined
          }
        >
          {label}
        </Link>
      )}
    </ContentContainer>
  );
};
